<template>
  <span class="inline">
    <template v-for="(part, index) in parsedContent" :key="index">
      <span v-if="part.type === 'text'" v-html="formatText(part.content)"></span>
      <TaxonomyPill
        v-else-if="part.type === 'pill'"
        :type="part.pillType"
        :name="part.name"
        :count="part.count"
      />
    </template>
  </span>
</template>

<script>
import TaxonomyPill from './TaxonomyPill.vue';

export default {
  name: 'ContentWithPills',
  components: {
    TaxonomyPill
  },
  props: {
    content: {
      type: String,
      required: true
    }
  },
  computed: {
    parsedContent() {
      if (!this.content) return [];
      
      // Parse content with pill placeholders: [pill:type:name:count]
      const parts = [];
      const regex = /\[pill:([^:]+):([^:]+):(\d+)\]/g;
      let lastIndex = 0;
      let match;
      
      while ((match = regex.exec(this.content)) !== null) {
        // Add text before pill
        if (match.index > lastIndex) {
          parts.push({
            type: 'text',
            content: this.content.substring(lastIndex, match.index)
          });
        }
        
        // Add pill
        parts.push({
          type: 'pill',
          pillType: match[1], // 'concept', 'format', 'topic', 'author'
          name: match[2].replace(/::/g, ':').replace(/\\\[/g, '[').replace(/\\\]/g, ']'), // Unescape
          count: parseInt(match[3])
        });
        
        lastIndex = regex.lastIndex;
      }
      
      // Add remaining text
      if (lastIndex < this.content.length) {
        parts.push({
          type: 'text',
          content: this.content.substring(lastIndex)
        });
      }
      
      // If no pills found, return entire content as text
      if (parts.length === 0) {
        parts.push({
          type: 'text',
          content: this.content
        });
      }
      
      return parts;
    }
  },
  methods: {
    formatText(text) {
      if (!text) return '';
      
      // Simple markdown-like formatting
      return text
        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
        .replace(/\*(.*?)\*/g, '<em>$1</em>')
        .replace(/`(.*?)`/g, '<code class="bg-gray-100 px-1 rounded text-sm">$1</code>')
        .replace(/\n/g, '<br>');
    }
  }
};
</script>

